"use strict";
/**
 * @module diffusion.selectors
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A Topic Selector Prefix
 */
var Prefix;
(function (Prefix) {
    /** Prefix used for {@link Type.PATH} expressions. */
    Prefix["PATH"] = ">";
    /** Prefix used for {@link Type.SPLIT_PATH_PATTERN} expressions. */
    Prefix["SPLIT_PATH_PATTERN"] = "?";
    /** Prefix used for {@link Type.FULL_PATH_PATTERN} expressions. */
    Prefix["FULL_PATH_PATTERN"] = "*";
    /** Prefix used for {@link Type.SELECTOR_SET} expressions. */
    Prefix["SELECTOR_SET"] = "#";
})(Prefix = exports.Prefix || (exports.Prefix = {}));
/**
 * Topic Selector type.
 */
var Type;
(function (Type) {
    /** A selector that selects a single topic. */
    Type["PATH"] = ">";
    /** A selector that is a split-path pattern. */
    Type["SPLIT_PATH_PATTERN"] = "?";
    /** A selector that is a full-path pattern. */
    Type["FULL_PATH_PATTERN"] = "*";
    /** A composite of multiple selectors. */
    Type["SELECTOR_SET"] = "#";
})(Type = exports.Type || (exports.Type = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/selectors/topic-selector.js
// module id = 203
// module chunks = 1